$(document).ready(function () {
    donateCounter()
})

$(window).on('scroll', function() {
    donateCounter()
})

function donateCounter() {
    let timer = 1000
    let numInterval = 100
    if ($(window).outerWidth() < 576) {
        timer = 500
        numInterval = 50
    }
    $('.js__donate_count').each((i, el) => {
        if ($(window).scrollTop() + $(window).outerHeight() - 100 >= $(el).offset().top) {
            let num = $(el).attr('data-num').replaceAll(' ', '')
            let isFloat = /^\d+\.\d+$/.test(num)
            if (typeof +num == 'number') {
                let count = 0
                let interval = num / 100
                let newValue
                let counter = setInterval(function () {
                    if (isFloat) {
                        newValue = count.toFixed(1)
                    } else {
                        newValue = parseInt(count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                    }
                    $(el).text(newValue)
                    count += interval
                }, 10)
                setTimeout(function () {
                    clearInterval(counter)
                    $(el).text($(el).attr('data-num')).removeAttr('class')
                }, timer)
            }
        }
    })
}